module.exports = __webpack_public_path__ + "img/circle.12a11f73.svg";